export default (state = {}, action) => {
  switch (action.type) {
    case 'BRANCHES':
      return action.branches;
    default:
      return state;
  }
};
